/* PAPAPATTES — Formatage de la note Judge.me (badge + widget avis)
   Demande Sid 24/08/2026 : la note doit s'afficher sans décimale
   inutile ("4" et non "4.0"), avec une virgule française si la
   décimale est réelle ("4,3" et non "4.3").

   Judge.me (bloc app "preview_badge" et "review_widget") pose l'attribut
   HTML data-score sur .jdgm-prev-badge__stars — c'est cet attribut que
   pp-refonte-produit.css affiche via content: attr(data-score). Comme le
   CSS ne peut pas reformater le texte d'un attribut, on le fait ici en
   JS : on écrit la version formatée dans un second attribut
   (data-score-fmt) que le CSS lit à la place (voir pp-refonte-produit.css).

   Le widget Judge.me se charge de façon asynchrone (parfois après
   plusieurs secondes) et peut se re-rendre (traduction, pagination des
   avis...), d'où le MutationObserver plutôt qu'un simple passage unique
   au chargement de la page. */
(function () {
  function formatScore(raw) {
    var num = parseFloat(String(raw).replace(',', '.'));
    if (isNaN(num)) return null;
    var rounded = Math.round(num * 10) / 10;
    var isWhole = Math.round(rounded) === rounded;
    if (isWhole) return String(Math.round(rounded));
    return String(rounded).replace('.', ',');
  }

  function applyTo(el) {
    var raw = el.getAttribute('data-score');
    if (!raw) return;
    var formatted = formatScore(raw);
    if (formatted !== null) {
      el.setAttribute('data-score-fmt', formatted);
    }
  }

  function scan(root) {
    (root || document)
      .querySelectorAll('[data-score]')
      .forEach(applyTo);
  }

  scan(document);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.hasAttribute && node.hasAttribute('data-score')) {
          applyTo(node);
        }
        if (node.querySelectorAll) {
          scan(node);
        }
      });
      if (mutation.type === 'attributes' && mutation.target.hasAttribute('data-score')) {
        applyTo(mutation.target);
      }
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-score'],
  });
})();
